module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-200.0aa9029a.woff";